module.exports = __webpack_public_path__ + "img/flag.16ffb6f7.jpg";